<template>
  <b-container class="registration-recording">
    <b-row align-h="center" align-v="center">
      <b-col md="10" class="text-center">
        <registration-form v-if="!registering && !registered" :fields="fields" @submit="register"></registration-form>
        <spinner size="3x" v-else></spinner>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Spinner from '@/components/togo/spinner';
import RegistrationForm from './registration-form';

const RegistrationRecording = {
  name: 'RegistrationRecording',

  props: ['recordingKey'],

  components: {
    RegistrationForm,
    Spinner
  },

  data() {
    return {
      registering: false,
      registered: false,
      fields: [
        {field: 'firstName'},
        {field: 'lastName'},
        {field: 'email'}
      ]
    };
  },

  created() {
    const {firstName, lastName, email} = this.$route.query;

    if (firstName && lastName && email) {
      this.register({firstName, lastName, email});
    }
  },

  methods: {
    async register(data) {
      const payload = {
        recordingKey: this.recordingKey,
        data
      };

      try {
        this.registering = true;
        const registration = await this.$store.dispatch('recording/registerForRecording', payload);

        if (registration.asset) {
          await this.$store.dispatch('recording/getRecordingAssets', {
            recordingKey: this.recordingKey,
            registrantKey: registration.registrantKey
          });
        } else {
          await this.$store.dispatch('recording/getWebinarRecording', {
            webinarKey: this.recordingKey, // TO CONFIRM
            recordingKey: this.recordingKey,
            registrantKey: registration.registrantKey
          });
        }
        this.registered = true;
        this.registering = false;

        this.$router.push({
          name: 'recording-view',
          params: {
            recordingKey: this.recordingKey,
            registrantKey: registration.registrantKey
          }
        });
      } catch (error) {
        this.registering = false;
        this.logger.log('cannot register for recording', {error});
      }
    }
  }
};

export default RegistrationRecording;
</script>

<style lang="sass">
  .registration-recording
    height: 100%

    .row
      height: 100%
</style>
